import Vue from "vue"
import { rrulestr } from "rrule";
import moment from 'moment';

Vue.filter("scheduleText", (schedule) => {
    if(schedule && schedule.rrule){
        const rrule = rrulestr(schedule.rrule);
        let rruleText = rrule.toText();

        const start = moment(schedule.startDate);
        if(start.isBefore(moment())){
          rruleText = `Started ${start.format("ddd, MMM DD YYYY")}, ${rruleText}`
        }
        else{
          rruleText = `Starting ${start.format("ddd, MMM DD YYYY")}, ${rruleText}`
        }

        if(!schedule.endDate){
          const untilIndex = rruleText.indexOf('until');
          if(untilIndex > 0){
            rruleText = `${rruleText.substring(0, untilIndex)} with no end date`
          }
        }
  
        return rruleText;
      }
      else if(schedule){
        return `${formatDate(schedule.startDate)} ${formatTime(schedule.startTime)} - ${formatTime(schedule.endTime)}`;
      }
      else{
        return "";
      }
})

Vue.filter("formatDate", (date) => { return moment(date).format("ddd, MMM DD YYYY") });

const formatDate = (date) => {
  return moment(date).format("ddd, MMM DD YYYY");
}

const formatTime = (time) => {
  return moment(time, "HH:mm").format("h:mm a");
}